import "./copy-to-clipboard-field.css";
import {Input, Tooltip} from "antd";
import {CheckCircleOutlined, CopyOutlined} from "@ant-design/icons";
import {useState} from "react";

interface CopyToClipboardFieldProps {
    content: string;
}

const CopyToClipboardField = ({ content }: CopyToClipboardFieldProps) => {
    const [copied, setCopied] = useState(false);

    async function copyTextToClipboard(text: string): Promise<boolean> {
        try {
            if (!navigator.clipboard || !navigator.clipboard.writeText) {
                console.warn("Clipboard API not supported or accessible.");
                return false;
            }
            await navigator.clipboard.writeText(text);
            console.log("Text successfully copied to clipboard!");
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
            return true;
        } catch (err) {
            console.error("Failed to copy text to clipboard:", err);
            return false;
        }
    }

    return (
        <Tooltip title={copied ? "Copied!" : "Click to copy to clipboard"}>
            <div className="copy-to-clipboard-field-container" onClick={() => copyTextToClipboard(content)}>
                <Input className="copy-to-clipboard-field" disabled={false} value={content} onClick={() => copyTextToClipboard(content)} />
                {copied ? <CheckCircleOutlined /> : <CopyOutlined />}
            </div>
        </Tooltip>
    )
}

export default CopyToClipboardField;